<template>
  <el-container class="h-100 w-100 bg-ff">
    <el-aside width="220px">
      <div class="menu">
        <!--<div v-if="permission.includes('progressTemplete')" class="bg-f3f4f7 ptb-20"><button class="btn-30-border-30313a-small mlr-20 text-left" @click="templateShow">选择工程进度模板<i class="el-icon-arrow-right ml-10"></i></button></div>-->
        <div v-if="modelList.length > 0" class="bg-ff">
          <div v-for="(item, index) in modelList" :key="index" @click="selectBtn(index, item)">
            <div class="ptb-12 plr-20 border-b-dashed-e2 text-left" v-if="index === selectedIndex"
              style="background: #45B5FA">
              <div class="font-14-ff mb-10">{{ item.name }}</div>
              <div class="flex">
                <div class="font-12-ff">计划开始时间：</div>
                <div class="font-12-ff">{{ Utils.formatDate(item.startPlanTime) }}</div>
              </div>
              <div class="flex">
                <div class="font-12-ff">计划结束时间：</div>
                <div class="font-12-ff">{{ Utils.formatDate(item.endPlanTime) }}</div>
              </div>
              <div class="flex flex-wrap">
                <div class="btn-16-bd-ff-r mt-10 mr-5" v-if="item.signStatus === 0">待验收</div>
                <div class="btn-16-bd-ff-r mt-10 mr-5" v-if="item.signStatus === 1">已验收</div>
                <div class="btn-16-bd-ff-r mt-10 mr-5" v-if="item.beyondTime > 0">已延期</div>
                <div class="btn-16-bd-ff-r mt-10" v-if="item.conduct">进行中</div>
              </div>
            </div>
            <div class="ptb-12 plr-20 border-b-dashed-e2 text-left" v-else>
              <div class="font-14-30313a mb-10">{{ item.name }}</div>
              <div class="flex">
                <div class="font-12-ff font-12-b9b9b9">计划开始时间：</div>
                <div class="font-12-ff font-12-b9b9b9">{{ Utils.formatDate(item.startPlanTime) }}</div>
              </div>
              <div class="flex">
                <div class="font-12-ff font-12-b9b9b9">计划结束时间：</div>
                <div class="font-12-ff font-12-b9b9b9">{{ Utils.formatDate(item.endPlanTime) }}</div>
              </div>
              <!--<div class="font-12-b9b9b9">计划时间：</div>-->
              <!--<div class="font-12-b9b9b9">{{Utils.formatDate(item.startPlanTime)}} ~ {{Utils.formatDate(item.endPlanTime)}}</div>-->
              <div class="flex flex-wrap">
                <div class="btn-16-bg-f3f4f7-r mt-10 mr-5" v-if="item.signStatus === 0">待验收</div>
                <div class="btn-16-bg-82b925-r mt-10 mr-5" v-if="item.signStatus === 1">已验收</div>
                <div class="btn-16-bg-ff5555-r mt-10 mr-5" v-if="item.beyondTime > 0">已延期</div>
                <div class="btn-16-bd-85-r mt-10" v-if="item.conduct">进行中</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-aside>
    <el-main class="flex-column" v-loading.body="fullscreenLoading">
      <div class="content flex-column flex-1 bg-f3f4f7">
        <div class="bg-ff flex-1" v-if="modelList.length > 0">
          <div v-for="(item, index) in picList" :key="index" v-if="item.photos.length > 0">
            <div class="text-left plr-20 pt-20 font-14-30313a">{{ item.name }}</div>
            <div class="flex flex-wrap plr-20 pt-20">
              <div class="mr-10 mb-10 bg-f3f4f7" v-for="(pic, index) in item.photos" :key="index">
                <div class="p-relative w-206">
                  <viewer :images="item.photos">
                    <img :src="'http://nail-mobile.oss-cn-qingdao.aliyuncs.com/' + pic.imgUrl" class="w-206" alt=""
                      style="display:block">
                  </viewer>
                  <!--<img src="https://dss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=2458227883,4095122505&fm=26&gp=0.jpg" class="w-206" alt="" style="display:block">-->
                </div>
                <!--<div class="border-e2 border-ra m-10 h-30 plr-10 font-12-30313a flex align-center text-left">-->
                <!--<div class="w-186" style="white-space: nowrap;text-overflow: ellipsis;overflow: hidden;word-break: break-all;">{{pic.name ? pic.name : '暂无'}}</div>-->
                <!--</div>-->
              </div>
            </div>
          </div>
        </div>
        <el-main v-else class="flex align-center justify-center">
          <div class="text-center">
            <div class="flex justify-center"><img src="/static/images/tip.png" class="icon-50 mb-20" alt=""></div>
            <div class="font-12-ff5555">注意：此客户还未添加工程进度模板！</div>
            <!--<div class="font-12-ff5555">请点击左上角“选择工程进度模板”按钮进行添加</div>-->
          </div>
        </el-main>
      </div>
    </el-main>
  </el-container>
</template>
<script>
import axiosx from 'axios'
export default {
  name: 'project-progress3.0',
  components: {},
  data () {
    return {
      token: null,
      projectId: null,
      processId: null,
      modelList: [],
      selectedIndex: 0,
      selectItem: {},
      picList: [],
      nowTemplate: {},
      fullscreenLoading: false
    }
  },
  mounted () {
    document.title = 'erp管理'
    this.token = this.$route.query.token
    this.projectId = this.$route.query.projectId
    this.processId = this.$route.query.processId
    this.getTemplate()
  },
  methods: {
    getTemplate () {
      axiosx({
        method: 'post',
        url: 'http://120.27.134.116:9103/progressData/queryByCid',
        headers: {
          'type': 'web',
          'token': this.token
        },
        params: {
          projectId: this.projectId,
          processId: this.processId
          // projectId: 'project_44238',
          // processId: 177

        }
      }).then(res => {
        if (res.data.success) {
          this.modelList = res.data.data.data
          this.nowTemplate = res.data.data.data[this.selectedIndex]
          this.getPicList()
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    selectBtn (a, item) {
      this.selectedIndex = a
      this.selectItem = item
      this.getTemplate()
    },
    getPicList () {
      this.fullscreenLoading = true
      axiosx({
        method: 'post',
        url: 'http://120.27.134.116:9103/checkStandardData/findByDataId',
        headers: {
          'type': 'web',
          'token': this.token
        },
        params: {
          dataId: this.nowTemplate.id
          // dataId: 24181

        }
      }).then(res => {
        if (res.data.success) {
          this.fullscreenLoading = false
          this.picList = res.data.data
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.w-206 {
  width: 256px;
  height: 206px;
}

.w-186 {
  width: 186px;
}

.el-aside {
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
  position: relative;
}

.el-main {
  padding: 0;
}

.aside-top {
  height: 5px;
  background: #45B5FA;
  width: 100%;
}

.el-aside .title {
  background: #ffffff;
  height: 50px;
  line-height: 50px;
  text-align: left;
  font-weight: bold;
  font-size: 18px;
  color: #30313a;
  padding-left: 20px;
}

.customerInfo {
  width: 100%;
  height: 50px;
  /*background: #fff;*/
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
  font-size: 12px;
  color: #30313a;
  text-align: left;
  padding-left: 20px;
  position: relative;
}

.close {
  width: 50px;
  height: 50px;
  background: #ff5555;
}

.customerInfo span {
  color: #b9b9b9;
}

.line {
  height: 32px;
  background: #f3f4f7;
  width: 1px;
  margin: 0 20px;
}

.hr {
  width: 100%;
  height: 1px;
  background: #e2e2e2;
  margin: 10px 0;
}

.hr-dashed {
  width: 100%;
  height: 1px;
  border-bottom: 1px dashed #e2e2e2;
  margin: 12px 0;
}

.content {
  padding: 10px 20px;
}

.decoration-line {
  width: 4px;
  height: 16px;
  background-color: #45B5FA;
  border-radius: 4px;
}

.img-206 {
  width: 206px;
  height: 206px;
  object-fit: cover;
}

.qualified {
  top: 0;
  right: 10px;
  width: 15px;
  height: 36px;
}

.qualified>img {
  width: 100%;
  height: 100%;
}

.unqualified {
  top: 0;
  right: 0;
  width: 49px;
  height: 46px;
}

.unqualified>img {
  width: 100%;
  height: 100%;
}

.location {
  left: 10px;
  right: 10px;
  bottom: 0;
  height: 20px;
  background: rgba(0, 0, 0, .2);
  border-radius: 4px;
}

.changeStatus {
  left: 10px;
  right: 10px;
  top: 10px;
  height: 20px;
}

.text-nowrap {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rectification {
  top: 10px;
  left: 10px;
  border-radius: 3px;
  height: 24px;
  background: #ffffff;
  padding: 0 10px;
  line-height: 24px;
}

.newImg {
  top: 10px;
  left: 10px;
  right: 10px;
}

.imgMark {
  height: 20px;
  background: rgba(0, 0, 0, .15);
  border-radius: 15px;
  padding: 0 6px;
}

.date /deep/ .el-input__icon {
  color: #30313a;
}

.btn-50-bg-f3f4f7 {
  height: 50px;
  align-items: center;
  background: #f3f4f7;
  border: 1px solid #e2e2e2;
  padding: 0 20px;
  border-radius: 3px;
  color: #30313a;
  font-size: 12px;
  z-index: 22;
}

.btn-50-bg-46b8b0 {
  height: 50px;
  align-items: center;
  background: #45B5FA;
  border: 1px solid #e2e2e2;
  padding: 0 20px;
  border-radius: 3px;
  font-size: 12px;
  color: #ffffff;
}

.w-114 {
  width: 114px;
}

.w-114 img {
  width: 114px;
  height: 114px;
  object-fit: cover;
}

.changeResult {
  width: 206px;
  height: 206px;
  object-fit: cover;
}</style>



// WEBPACK FOOTER //
// src/pages/customer/projectProgress3.vue